import * as graphql from '@treams/treams-network';
import { QuillText } from '@treams/treams-ui';

export default function OpenQuestionDisplay(props: { item: graphql.EvaluationSubmissionItem }) {
	return <QuillText value={props.item.openQuestion} />;
}
